module.exports = "../images/icons/idc-logo.svg";